/**
 * @ignore
 *
 * This file contains the constants of action types to be reused.
 *
 * See <https://redux.js.org/style-guide/style-guide#write-action-types-as-domaineventname> for more info.
 */

export const SET_USER = 'SET USER';
